import { useState, useEffect } from "react";

// In-app motion preference (independent of the OS setting so a visitor can
// choose stillness without touching system preferences). Default: motion ON.
const KEY = "moire.reduceMotion";
const EVT = "moire:motionchange";

export function getReduceMotion() {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(KEY) === "1";
}

export function setReduceMotion(v) {
  window.localStorage.setItem(KEY, v ? "1" : "0");
  window.dispatchEvent(new Event(EVT));
}

export function useReduceMotion() {
  const [reduce, setReduce] = useState(getReduceMotion);
  useEffect(() => {
    const on = () => setReduce(getReduceMotion());
    window.addEventListener(EVT, on);
    window.addEventListener("storage", on);
    return () => {
      window.removeEventListener(EVT, on);
      window.removeEventListener("storage", on);
    };
  }, []);
  return reduce;
}
